import { render, staticRenderFns } from "./AddFunds.vue?vue&type=template&id=4353a50c&"
import script from "./AddFunds.vue?vue&type=script&lang=js&"
export * from "./AddFunds.vue?vue&type=script&lang=js&"
import style0 from "./AddFunds.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports